import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const UserPhoneIcon: FC<IconType> = (props) => {
  const { width, height, color, dataTestId } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      data-test-id={dataTestId}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className="w-6 h-6 with_stroke"
      viewBox="0 0 40 40"
    >
      <g className="layer">
        <title>Layer 1</title>
        <line
          data-color="color-2"
          fill="none"
          id="svg_1"
          stroke={color}
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.4"
          transform="matrix(1 0 0 1 0 0)"
          x1="9.49"
          x2="31.49"
          y1="29.15"
          y2="29.15"
        />
        <path
          d="m28.49,34.84l-16,0a3,3 0 0 1 -3,-3l0,-24a3,3 0 0 1 3,-3l16,0a3,3 0 0 1 3,3l0,24a3,3 0 0 1 -3,3z"
          fill="none"
          id="svg_3"
          stroke={color}
          strokeLinecap="square"
          strokeMiterlimit="10"
          strokeWidth="2.4"
        />
      </g>
    </svg>
  );
};
